// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1ogil","selects":"Documents_selects__1kDf8"};